import React, { useState } from 'react';
import { Grid } from '@material-ui/core';
import { PriceOverrideContainer, Text } from './index.styled';
import PriceOverrideTable from './PriceOverrideTable';
import CustomLabel from 'src/pages/reportUsage/common/customLabel/CustomLabel';
import Select from 'src/common/refactoredComponents/select/Select';
import { sizes } from 'src/styles/Media.styled';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import AccountOwnedList from './AccountOwnedList';
import SummaryMobile from 'src/pages/reportUsage/record/components/summary/SummaryMobile.jsx';
import {
    getTotalQuantity,
    flattenLotSerialArrayOfArrays,
} from 'src/pages/reportUsage/utils/eventHandlerUtil';
import { useTranslation } from 'react-i18next';
import { isMobileDevice } from 'src/utils/util';
import { useDynatracePageName } from 'src/common/hooks/useDynatracePageName';
import { MANDATORY, pageNames, VISIBLE } from 'src/constants/appConstants';
import AlertMsg from 'src/pages/reportUsage/common/AlertMsg';
import { ErrorMsgContainer } from '../itemsList/LotSerialQtyInput';
import { noPriceErrorMsg } from 'src/pages/reportUsage/utils/dataModificaionUtil';
import {
    TextArea,
    TextAreaContainer,
} from 'src/pages/equity/components/cart/priceOverride/index.styled';
import { useDispatch, useSelector } from 'react-redux';

const PriceOverride = ({
    itemTableData,
    priceOverrideTableData,
    setPriceOverrideTableData,
    resetAllClickHandler,
    priceOverrideReason,
    setPriceOverrideReason,
    priceOverrideReasonsList,
    isReportPayment = false,
    pricingNotes,
    setPricingNotes,
}) => {
    const { t } = useTranslation();
    const winWidth = window.innerWidth;
    const dispatch = useDispatch();

    const [accOwnedCard, toggleAccOwnedCard] = useState(false);

    const {
        priceOverrideReasonVisibilityUsage,
        priceOverrideReasonMandatoryUsage,
        priceOverrideCommentsVisibilityUsage,
        priceOverrideCommentsMandatoryUsage
    } = useSelector((state) => state.loginReducer);

    useDynatracePageName(pageNames.reportUsagePriceOverRide);
    const handleNote = (note) => {
        const lengthOfNote = note.length;
        if (lengthOfNote <= 1000) {
            setPricingNotes(note);
            dispatch({
                type: 'SET_LOCAL_PRICE_COMMENTS',
                payload: pricingNotes,
            });
        } else {
            const sliceLastIdx = 1000 - lengthOfNote;
            setPricingNotes(note.slice(0, sliceLastIdx));
        }
    };

    return (
        <React.Fragment>
            <PriceOverrideContainer>
                <Grid
                    spacing={1}
                    container
                    xs={12}
                    direction={
                        winWidth <= sizes.mobileDevice ? 'column' : 'row'
                    }
                    justifyContent={'space-between'}
                >
                    {priceOverrideReasonVisibilityUsage === VISIBLE && <Grid
                        container
                        xs={12}
                        sm={winWidth > sizes.mediumDevice ? 4 : 5}
                        md={winWidth > sizes.mediumDevice ? 4 : 5}
                        alignItems={
                            winWidth <= sizes.mobileDevice
                                ? 'undefined'
                                : 'center'
                        }
                        direction={
                            winWidth <= sizes.mobileDevice ? 'column' : 'row'
                        }
                        style={{
                            marginLeft: '5px',
                            marginBottom: '10px',
                            padding: '20px',
                            paddingTop: '10px',
                            paddingBottom: '42px',
                            borderRadius: '7px',
                            boxShadow:
                                'rgba(0, 0, 0, 0.2) 0px 3px 1px -2px, rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px',
                            backgroundColor: 'rgb(255, 255, 255)',
                            marginRight:
                                winWidth === sizes.largeDevice
                                    ? '-20%'
                                    : winWidth > sizes.mobileDevice
                                        ? '-10%'
                                        : '',
                        }}
                    >
                        <Grid item>
                            <Text margin={'0 0 5px 0'} fontSize={'15px'}>
                                {t(
                                    'consignmentBilling.priceOverride.priceOverrideReason'
                                )}{' '}
                                {priceOverrideReasonMandatoryUsage === MANDATORY && <text
                                    style={{
                                        color: '#ED002A',
                                        paddingRight: 7,
                                    }}
                                >
                                    {'*'}
                                </text>}
                            </Text>
                        </Grid>
                        <Grid
                            item
                            md={12}
                            sm={12}
                            xs={12}
                            style={{
                                marginTop:
                                    winWidth > sizes.mobileDevice && priceOverrideCommentsVisibilityUsage === VISIBLE && '-8%',
                            }}
                        >
                            <Select
                                id="reportUsage-index-record-priceOverrideReason"
                                value={priceOverrideReason}
                                options={
                                    priceOverrideReasonsList
                                        ? priceOverrideReasonsList
                                        : []
                                }
                                onChange={setPriceOverrideReason}
                                placeholder={t(
                                    'reportUsage.record.priceOverride.index.priceOverrideReason'
                                )}
                                optionLabel="value"
                                style={{
                                    marginLeft:
                                        window.innerWidth > sizes.mobileDevice
                                            ? '3px'
                                            : '',
                                    marginBottom:
                                        winWidth > sizes.mobileDevice && '20px',
                                }}
                                showClear={priceOverrideReason}
                            />
                        </Grid>
                    </Grid>}
                    {priceOverrideCommentsVisibilityUsage === VISIBLE && <Grid
                        container
                        xs={12}
                        sm={4}
                        md={4}
                        alignItems={
                            winWidth <= sizes.mobileDevice
                                ? 'undefined'
                                : 'center'
                        }
                        direction={
                            winWidth <= sizes.mobileDevice ? 'column' : 'row'
                        }
                        style={{
                            marginLeft: '5px',
                            marginBottom:
                                winWidth <= sizes.mobileDevice ? '0px' : '10px',
                            // marginTop:
                            //     winWidth <= sizes.mobileDevice
                            //         ? winWidth > sizes.mobileDevice && '-25px'
                            //         : '0px',
                            padding: '20px',
                            borderRadius: '7px',
                            boxShadow:
                                'rgba(0, 0, 0, 0.2) 0px 3px 1px -2px, rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px',
                            backgroundColor: 'rgb(255, 255, 255)',
                        }}
                    >
                        <Grid item>
                            <Text margin={'0 0 5px 0'} fontSize={'15px'}>
                                {t(
                                    'reportUsage.review.priceOverrideAndSignature.priceOverRideComments'
                                )}{' '}
                                {priceOverrideCommentsMandatoryUsage === MANDATORY && <text
                                    style={{
                                        color: '#ED002A',
                                        paddingRight: 7,
                                    }}
                                >
                                    {'*'}
                                </text>}
                            </Text>
                        </Grid>
                        <Grid item md={12} sm={12} xs={12}>
                            <TextAreaContainer>
                                <TextArea
                                    id={'reportUsage-index-record-priceOverrideComments'}
                                    height={
                                        window.innerWidth <= sizes.mobileDevice
                                            ? '81px'
                                            : '70px'
                                    }
                                    fontFamily={'AvenirNextWorld Regular'}
                                    value={pricingNotes}
                                    onChange={(e) => handleNote(e.target.value)}
                                ></TextArea>
                                <span
                                    className="pricing-note-bottm-text"
                                    style={{ fontSize: '12px' }}
                                >
                                    {/* Add a new note (max 4000 characters) */}
                                    {`${(pricingNotes
                                        ? 1000 - pricingNotes?.length
                                        : 1000
                                    ).toLocaleString('en-US')} ${t(
                                        'equity.surgery.remainchar'
                                    )}`}
                                </span>
                            </TextAreaContainer>
                        </Grid>
                    </Grid>}
                    <Grid
                        container
                        sm={1}
                        md={1}
                        justifyContent="flex-end"
                        alignItems="flex-end"
                    >
                        <CustomLabel
                            label={t('equity.priceOverride.resetAll')}
                            onLabelClick={resetAllClickHandler}
                            styles={{
                                textAlign: 'end',
                                alignSelf: 'flex-end',
                                fontFamily: 'AvenirNextWorld Demi',
                                letterSpacing: '-0.11px',
                                fontSize: '14px',
                                color: '#1010EB',
                                paddingTop:
                                    winWidth <= sizes.mobileDevice
                                        ? '11px'
                                        : '0px',
                                paddingBottom:
                                    winWidth <= sizes.mobileDevice
                                        ? '11px'
                                        : '8px',
                            }}
                            cursor={'pointer'}
                        />
                    </Grid>
                </Grid>
                {itemTableData?.length > 0 &&
                    itemTableData.some(
                        (item) => item.exclusionStatus === noPriceErrorMsg
                    ) && (
                        <ErrorMsgContainer padding={'10px 0'}>
                            <AlertMsg
                                message={t(
                                    'productValidationMessages.noPriceErrorMsg'
                                )}
                            />
                        </ErrorMsgContainer>
                    )}
                <PriceOverrideTable
                    priceOverrideTableData={priceOverrideTableData}
                    setPriceOverrideTableData={setPriceOverrideTableData}
                />
                {!isReportPayment && (
                    <CollapsableCard id="reportUsage-index-priceOverride-accountOwned"
                        title={`${t(
                            'consignmentBilling.itemList.accountOwned'
                        )} (${getTotalQuantity(
                            flattenLotSerialArrayOfArrays(
                                'accOwned',
                                itemTableData
                            )
                        )})`}
                        onClick={() => toggleAccOwnedCard(!accOwnedCard)}
                        isExpanded={accOwnedCard}
                        noCardData={
                            getTotalQuantity(
                                flattenLotSerialArrayOfArrays(
                                    'accOwned',
                                    itemTableData
                                )
                            ) === 0
                        }
                    >
                        {accOwnedCard &&
                            itemTableData.filter((item) => item.accountOwned)
                                ?.length > 0 &&
                            itemTableData
                                .filter((item) => item.accountOwned)
                                .map((data, index) => (
                                    <AccountOwnedList
                                        data={data}
                                        key={`${data} ${index}`}
                                    />
                                ))}
                    </CollapsableCard>
                )}
                <SummaryMobile
                    itemTableData={priceOverrideTableData?.concat(
                        itemTableData?.filter((item) => item.accountOwned)
                    )}
                    accountLabel={t('reportUsage.summary.accountOwned')}
                    accountNotBilled={t('reportUsage.summary.notBilled')}
                    isDesktop={!isMobileDevice()}
                    isMobile={isMobileDevice()}
                    displayPrice
                />
            </PriceOverrideContainer>
        </React.Fragment>
    );
};

export default PriceOverride;
